import { Metric } from "./Metric";
import { PanelSection } from "./PanelSection";
import type { BoundsInspectorProps } from "./types";

export function BoundsInspector({ selectedCount, bounds, rotation, fillControls, onBoundsCommit, onRotationCommit }: BoundsInspectorProps) {
  const disabled = selectedCount === 0 || !bounds;

  return (
    <PanelSection title={selectedCount > 1 ? "Selection" : "Position"}>
      <div className="grid grid-cols-2 gap-2">
        <Metric
          label="X"
          value={bounds?.x}
          disabled={disabled}
          onCommit={value => onBoundsCommit({ ...bounds!, x: value })}
        />
        <Metric
          label="Y"
          value={bounds?.y}
          disabled={disabled}
          onCommit={value => onBoundsCommit({ ...bounds!, y: value })}
        />
        <Metric
          label="W"
          value={bounds?.width}
          disabled={disabled || fillControls?.width.enabled === true}
          min={0}
          onCommit={value => onBoundsCommit({ ...bounds!, width: Math.max(0, value) })}
        />
        {fillControls ? (
          <FillToggle
            checked={fillControls.width.enabled}
            onChange={fillControls.width.onChange}
          />
        ) : null}
        <Metric
          label="H"
          value={bounds?.height}
          disabled={disabled || fillControls?.height.enabled === true}
          min={0}
          onCommit={value => onBoundsCommit({ ...bounds!, height: Math.max(0, value) })}
        />
        {fillControls ? (
          <FillToggle
            checked={fillControls.height.enabled}
            onChange={fillControls.height.onChange}
          />
        ) : null}
        <Metric
          label="A"
          value={rotation}
          disabled={disabled}
          onCommit={onRotationCommit}
        />
      </div>
    </PanelSection>
  );
}

function FillToggle({ checked, onChange }: { checked: boolean; onChange: (checked: boolean) => void }) {
  return (
    <label className="flex h-7 items-center justify-between rounded bg-white/[0.04] px-1.5 text-[11px] text-slate-300">
      <span>Fill</span>
      <input
        type="checkbox"
        checked={checked}
        onChange={event => onChange(event.currentTarget.checked)}
        className="h-3.5 w-3.5 accent-sky-500"
      />
    </label>
  );
}
